import React, { Component, PropTypes } from "react";
import { inject, observer } from 'mobx-react';
import * as mobx from 'mobx';
import { toJS } from 'mobx'
import { Tree, Modal, message, Button } from "antd";
import { WeaTreeNew, WeaLocaleProvider } from "ecCom";
import { stopEvent, getInputKeys } from "../../util/TreeUtil";
import "../../style/tree.less";
const getLabel = WeaLocaleProvider.getLabel
const TreeNode = Tree.TreeNode;
const confirm = Modal.confirm;
@observer
class FavDirTree extends Component {
    constructor(props){
        super(props)
        this.state={
            newTreeData:false
        }
    }
    componentDidMount() {
        let { favouriteDirStore } = this.props;
        favouriteDirStore.getObjTree(this)
    }
    asyncLoad = (nodeid) => {
        let { favouriteDirStore } = this.props;
        function fn() {
            return new Promise((resolve, reject) => {
                resolve(favouriteDirStore.loadTreedata(nodeid))  //这是一个异步函数                                                           
            })
        }
        let fn_1 = async function () {
            await fn();//等待异步操作执行完了后执行的方法
            return new Promise((resolve) => { //loadData接口需要一个promise对象，所以这里要包装返回一个promise对象
                const data = {
                    datas: favouriteDirStore.loadedTreeData
                }
                resolve(data)
            })
        }
        return fn_1();
    }
    findParentId = (data) => {
        var arr = data.split("__")
        var fatherid = arr[arr.length - 2].split("-")[arr.length == 2 ? 0 : 1]
        return fatherid
    }
    //设置父节点的删除符号
    setOPS = (data, target,mode) => {
        let hasChildFlag = false
        data.map((val) => {
            if (val.children) {
                let s = val.children
                this.setOPS(s, target)
            }
            if (val.nodeid == target) {
                    val.children.map(value=>{
                        let c = 'deleted' in value
                        if(c==false){
                            hasChildFlag = true
                            
                        }
                    })
                    if(hasChildFlag==true){
                        val.ops[2].type = ""

                    }else{
                        val.ops[2].type = "delete"

                    }    
            }


        })
        this.props.favouriteDirStore.initTreeData = data
        this.setState({newTreeData:true})
        
    }
    dragSet=(dragNode, targetNode, datas)=>{
        datas.map((val) => {
             if (val.children) {
                if(val.children.length==0){
                    val.ops[2].type = "delete"
                }else{
                    val.ops[2].type = ""
                }
                let s = val.children
                this.dragSet(dragNode, targetNode, s)
            }
            
        })
        this.props.favouriteDirStore.initTreeData = datas
        this.setState({newTreeData:true})
    }
    //找父节点id
    testFind =(node,treeData,mode)=>{
        if(node.parentTreeKey){
            let FID = this.findParentId(node.parentTreeKey)
            this.setOPS(treeData,FID,mode)
        }
    }
    render() {
        let { favouriteDirStore, onSelect } = this.props;
        return (
            <WeaTreeNew
                ref='tree'
                draggable
                // addToLast
                // hasRadio={true}
                // radioCheckedKey={483}
                // onRadioCheck={(radioCheckedKey) => { console.log(radioCheckedKey) }}
                selectedKeys={this.props.favouriteDirStore.selectedKey}
                deleteConfirmText={getLabel('501373', '删除目录，该目录下的收藏将自动移至默认目录"我的收藏"。确定要删除吗？')}
                defaultParentIcon={'icon-coms-LargeArea'}
                onDatasChange={(datas) => {window.treeData = datas;}}
                onSelect={(ids, nodeids, nodes, event) => { onSelect(nodeids[0]) }}
                datas={toJS(favouriteDirStore.initTreeData)}
                loadData={(item) => { return this.asyncLoad(item.nodeid) }}
                onAdd={(value, node) => {this.setOPS(window.treeData,node == undefined ? '0' : node.nodeid,'add'); return favouriteDirStore.addDirectory(node == undefined ? '0' : node.nodeid, value) }}
                onEdit={(value, node) => { return favouriteDirStore.editDirectory(value, node) }}
                onDelete={(node) => {let that = this; favouriteDirStore.deleteNode(node.nodeid);setTimeout(function(){that.testFind(node,window.treeData,'delete') },0) }}
                onDrag={(dragNode, targetNode, datas) => {
                    favouriteDirStore.initTreeData = datas;
                    favouriteDirStore.saveDragNode(dragNode, targetNode, datas);
                    this.dragSet(dragNode, targetNode, datas)
                }}
            >{this.state.newTreeData}</WeaTreeNew>)
    }
}

FavDirTree.PropTypes = {
    onSelect: React.PropTypes.func.isRequired,
    hasRadio: React.PropTypes.bool
}

export default FavDirTree;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/dir/FavDirTree.js